import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

import { UserLotQuery } from '../../graphql/service/graphql-auto-main-service';

@Component({
  selector: 'app-lot-last-visit-date',
  templateUrl: './lot-last-visit-date.component.html',
  styleUrls: ['./lot-last-visit-date.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LotLastVisitDateComponent {
  @Input() savedLot?: UserLotQuery['lot'];

  get lastVisitDate(): string | null {
    return this.savedLot?.currentUserLastLotSourceView?.updatedAt || null;
  }
}
